import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';

@Component({
  selector: 'homey-text-page',
  imports: [],
  templateUrl: './text-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextPageComponent {
  @HostBinding('class') class = 'flex flex-col gap-8';
}
